import React from 'react';
import FaithJourneyDrawerContent from './FaithJourneyDrawerContent';
import { XMarkIcon, UserCircleIcon } from '@heroicons/react/24/outline';

const FaithJourneyDrawer = ({ open, onClose, discipleData, mentorDetails }) => {
  console.log('[FaithJourneyDrawer] mentorDetails.photoURL:', mentorDetails?.photoURL);
  return (
    <div className={`fixed inset-0 z-50 flex ${open ? '' : 'pointer-events-none'}`}>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-30 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
        aria-label="Close faith journey drawer"
      />
      {/* Drawer Panel */}
      <div
        className={`ml-auto h-full bg-white shadow-none max-w-md sm:max-w-lg transition-transform duration-300 ease-in-out ${open ? 'translate-x-0' : 'translate-x-full'} flex flex-col relative`}
        style={{ minWidth: '320px' }}
        role="dialog"
        aria-modal="true"
      >
        {/* Header Bar */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div className="flex items-center min-w-0">
            <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
              {mentorDetails?.photoURL ? (
                <img
                  src={mentorDetails.photoURL}
                  alt={discipleData?.name || 'Disciple'}
                  className="h-full w-full object-cover"
                />
              ) : discipleData?.name ? (
                <span className="text-lg font-semibold text-gray-500">
                  {discipleData.name.split(' ').map(n => n[0]).join('').slice(0,2)}
                </span>
              ) : (
                <UserCircleIcon className="h-8 w-8 text-gray-400" />
              )}
            </div>
            <div className="ml-3 min-w-0">
              <h2 className="text-lg font-bold text-gray-900 truncate">Faith Journey</h2>
              <p className="text-gray-500 text-xs truncate">Update basic life context for better discipleship direction.</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="ml-auto p-2 rounded-full hover:bg-gray-100"
            aria-label="Close drawer"
          >
            <svg className="h-6 w-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {/* Drawer Content */}
        <div className="flex-1 flex flex-col overflow-y-auto">
          <FaithJourneyDrawerContent />
        </div>
      </div>
    </div>
  );
};

export default FaithJourneyDrawer; 